import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { API_BASE_URL } from "../../config";
import usePermissions from "../hooks/usePermissions";
import axios from "axios";
import Navbar from "../../Layouts/Navbar";
import Footer from "../../Layouts/Footer";
import LeftSideBar from "../../Layouts/LeftSideBar";
import { toast } from "react-toastify";
import Loader from "../../Loader/loader";
import { Pagination } from "@mui/material";
import TableLoader from "../../Loader/TableLoader";
import { authHeaders,getSessionToken } from "../utils/session";
import { apiMessage } from "../utils/apiError";

const ManageSubscribe = () => {
  const { canDelete } = usePermissions("/cms/managesubscribe");

  const [listPageData, setListPageData] = useState();
  const [token, setToken] = useState(getSessionToken());
  const [status, setStatus] = useState(0);
  const [isLoading, setIsLoading] = useState(true);

  const [pageSize, setPageSize] = useState();
  const [pageApi, setPageApi] = useState(1);


  useEffect(() => {
    setToken(getSessionToken());
    loadContent();
  }, []);

  const loadContent = async () => {
    setIsLoading(true);
    let param = {
      page: pageApi,
      limit: 10,
    };
    await axios
      .get(`${API_BASE_URL}/get-subscriber-list`, {
        headers: {
          ...authHeaders(),
          "content-type": "multipart/form-data",
        },
        params: param,
      })
      .then((response) => {
        setListPageData(response.data.data.reverse());
        setIsLoading(false);
      })
      .catch((error) => {
        setIsLoading(false);
        toast.error(apiMessage(error));
      });
  };

  const handleDelete = (id) => {
    const result = window.confirm("Do you want to delete ?");

    if (result) {
      axios
        .get(`${API_BASE_URL}/subscriber-delete/${id}`, {
          headers: {
            ...authHeaders(),
          },
        })
        .then((response) => {
          if (response.data.status === "200") {
            toast.success("deleted successfully");
            axios
              .get(`${API_BASE_URL}/subscriber-list`, {
                headers: {
                  ...authHeaders(),
                },
              })
              .then((response) => {
                setListPageData(response.data.result.reverse());
              })
              .catch((error) => {
                toast.error(apiMessage(error));
              });
          }
        });
    }
  };

  const handleActive = async (id) => {
    const res = await axios.post(
      `${API_BASE_URL}/activate-page`,
      { status: status, id: id },
      {
        headers: {
          ...authHeaders(),
        },
      }
    );
    const response = JSON.parse(JSON.stringify(res));
    console.log(response);
    if (response.data.status === 200) {
      loadContent();
      if (status == 1) {
        toast.success("Active successfully");
      } else {
        toast.success("Inactive successfully");
      }
    }
  };

  return (
    <>
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12">
                <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                  <h4 className="mb-sm-0 font-size-18">Manage Subscribe </h4>

                  <div className="page-title-right">
                    <ol className="breadcrumb m-0">
                      <li className="breadcrumb-item">
                        <a href="javascript: void(0);">CMS</a>
                      </li>
                      <li className="breadcrumb-item active">
                        Manage Subscribe
                      </li>
                    </ol>
                  </div>
                </div>
              </div>
            </div>
            {/* <div className="row justify-content-end">
              <div className="col-lg-12 mb-2 ">
                <Link
                  to={"/cms/managepage/addpage"}
                  data-repeater-create
                  type="button"
                  className="btn btn-success inner"
                  value="Add Number"
                >
                  Add a page
                </Link>
              </div>
            </div> */}

            <div className="row">
              <div className="col-lg-12">
                <div className="card">
                  <div className="card-body">
                    <h4 className="card-title mb-4">
                      Page List ({listPageData?.length})
                    </h4>
                   
                      <div className="table-responsive">
                        <table className="table align-middle table-nowrap mb-0">
                          <thead className="table-light">
                            <tr>
                              {/* <th styles="width: 20px;">
                              <div className="form-check font-size-16 align-middle">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  id="transactionCheck01"
                                />
                                <label
                                  className="form-check-label"
                                  for="transactionCheck01"
                                ></label>
                              </div>
                            </th> */}
                              <th className="align-middle">SN NO.</th>
                              <th className="align-middle">Email ID</th>
                              {/* <th className="align-middle">URL</th> */}
                              <th className="align-middle">Date</th>
                              <th className="align-middle">Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            { isLoading ? 
                            <TableLoader count={3} /> :
                            (listPageData?.map((item) => (
                              <>
                                <tr>
                                  {/* <td>
                                  <div className="form-check font-size-16">
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      id="transactionCheck02"
                                    />
                                    <label
                                      className="form-check-label"
                                      for="transactionCheck02"
                                    ></label>
                                  </div>
                                </td> */}
                                  <td>
                                    <a
                                      href="javascript: void(0);"
                                      className="text-body fw-bold"
                                    >
                                      {item.id}
                                    </a>
                                  </td>
                                  <td>{item.email}</td>
                                  <td>{item.subscription_date}</td>

                                  <td>
                                    {canDelete && (
                                    <button
                                      type="button"
                                      className="btn btn-danger btn-sm btn-rounded waves-effect waves-light ms-2"
                                      onClick={() => {
                                        handleDelete(item.id);
                                      }}
                                    >
                                      <i className="fa fa-trash"></i>
                                    </button>
                                    )}
                                  </td>
                                </tr>
                              </>
                            )))}
                          </tbody>
                        </table>
                      </div>
                     {!isLoading && pageSize !== 1 && (
                      <div className="d-flex justify-content-center mt-2">
                        <Pagination
                          count={pageSize}
                          page={pageApi}
                          onChange={(e, value) => {
                            // console.log(value, "vslue");
                            setPageApi(value);
                          }}
                          color="primary"
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ManageSubscribe;
